var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page-layout',[_c('span',{staticClass:"display-1 d-block text-primary pt-4"},[_c('i',{staticClass:"fa fa-wrench"})]),_c('div',{staticClass:"mb-4 mt-4 lead"},[_vm._v(_vm._s(_vm.$t("error-pages.body-503")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }